module.exports = __webpack_public_path__ + "img/FPTemp6.604a346d.png";